import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { MessageCircle } from 'lucide-react';
import { contactInfo, exportTerms, WHATSAPP_DEFAULT } from '../mock';

const ExportTerms = () => {
  return (
    <div className="min-h-screen bg-white pt-20">
      <Helmet>
        <title>Export Terms & Business Policies | Quality, Shipping, Documentation – Agro Corp India</title>
        <meta name="description" content="Review Agro Corp India's export policies: stringent quality assurance (FSSAI compliance), reliable global shipping & logistics, and comprehensive export documentation." />
        <meta name="keywords" content="export terms India, agricultural export policies, quality assurance food export, shipping logistics India, export documentation, Agro Corp India business policies" />
        <link rel="canonical" href="https://www.agrocorpindia.com/export-terms" />
      </Helmet>

      <div className="container mx-auto px-4 py-12">
        <h1 className="text-4xl sm:text-5xl font-bold text-center mb-4 font-montserrat text-green-900">
          Export Terms & Policies
        </h1>
        <p className="text-lg text-center mb-12 font-inter text-gray-600 max-w-2xl mx-auto">
          AgroCorp India is committed to delivering premium agricultural products globally with complete transparency and reliability.
        </p>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto font-inter">

          {/* Quality Assurance */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100" data-testid="quality-assurance-card">
            <h2 className="text-2xl font-semibold mb-4 text-green-900 font-montserrat">Quality Assurance</h2>
            <ul className="list-disc pl-5 space-y-2 text-gray-600">
              {exportTerms.qualityAssurance.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Shipping & Logistics */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100" data-testid="shipping-logistics-card">
            <h2 className="text-2xl font-semibold mb-4 text-green-900 font-montserrat">Shipping & Logistics</h2>
            <ul className="list-disc pl-5 space-y-2 text-gray-600">
              {exportTerms.shippingLogistics.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
          </div>

          {/* Documentation - Full Width */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 md:col-span-2" data-testid="documentation-card">
            <h2 className="text-2xl font-semibold mb-4 text-green-900 font-montserrat">Export Documentation</h2>
            <p className="text-gray-600 mb-3">We provide complete and accurate documentation for smooth customs clearance, including:</p>
            <div className="grid sm:grid-cols-2 gap-x-8 gap-y-1">
              <ul className="list-disc pl-5 space-y-1 text-gray-600">
                {exportTerms.documentation.slice(0, 4).map((doc, index) => (
                  <li key={index}>{doc}</li>
                ))}
              </ul>
              <ul className="list-disc pl-5 space-y-1 text-gray-600">
                {exportTerms.documentation.slice(4).map((doc, index) => (
                  <li key={index}>{doc}</li>
                ))}
              </ul>
            </div>
          </div>

          {/* MOQ - Full Width */}
          <div className="bg-white p-6 rounded-lg shadow-md border border-gray-100 md:col-span-2" data-testid="moq-card">
            <h2 className="text-2xl font-semibold mb-4 text-green-900 font-montserrat">Minimum Order Quantity</h2>
            <p className="text-gray-600">{exportTerms.minimumOrder}</p>
          </div>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-gray-700 font-inter mb-2">For specific inquiries or custom requirements, please contact our export division.</p>
          <p className="text-gray-500 text-sm mb-6">{contactInfo.email} &nbsp;|&nbsp; {contactInfo.phone} &nbsp;|&nbsp; {contactInfo.address}</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a href={WHATSAPP_DEFAULT} target="_blank" rel="noopener noreferrer" className="inline-block">
              <button className="bg-green-600 text-white px-8 py-3 rounded-lg hover:bg-green-700 transition font-inter font-medium shadow-md hover:shadow-lg flex items-center justify-center" data-testid="export-terms-whatsapp-btn">
                <MessageCircle className="mr-2 w-5 h-5" />
                Inquire on WhatsApp
              </button>
            </a>
            <Link to="/contact" className="inline-block">
              <button className="bg-amber-600 text-white px-8 py-3 rounded-lg hover:bg-amber-700 transition font-inter font-medium shadow-md hover:shadow-lg" data-testid="export-terms-contact-btn">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportTerms;
